import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../ui/AlertDialog/AlertDialog";
import { t } from "i18next";
import { useEffect } from "react";
import { useFetch } from "../../../hooks/useFetch";
import { Button } from "../../../ui/Button";
import { Device } from "../../../types/types";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
  devices: Device[];
  setDevices: Function;
};

const DeleteDevice = ({ id, isDeleteOpen, closeModal, devices, setDevices }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading }, doFetchDelete] = useFetch(
    `/administration/devices/devices/${id}`,
    true
  );

  useEffect(() => {
    if (!deleteResponse) return;
    const withoutDevice = devices?.filter((device) => device.id != id)!;
    setDevices(withoutDevice);
    openStateChange();
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить устройство</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить устройство?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDevice;
